import type { paths } from "../types/address-book-api.generated";
import * as api from "./client";

// ============================================================================
// Type Definitions
// ============================================================================

type APICompany =
  paths["/api/v1/companies"]["get"]["responses"]["200"]["content"]["application/json"]["companies"][number];

export type Company = APICompany;

// ============================================================================
// Type Aliases from Generated OpenAPI Types
// ============================================================================

export type CompaniesListResponse =
  paths["/api/v1/companies"]["get"]["responses"]["200"]["content"]["application/json"];

// ============================================================================
// Service
// ============================================================================

export const companies = {
  getAll: async (filters?: {
    regionId?: string;
    limit?: number;
    offset?: number;
  }): Promise<CompaniesListResponse> => {
    const params = new URLSearchParams();
    if (filters?.regionId) params.append("regionId", filters.regionId);
    if (filters?.limit !== undefined) params.append("limit", filters.limit.toString());
    if (filters?.offset !== undefined) params.append("offset", filters.offset.toString());

    const query = params.toString() ? `?${params.toString()}` : "";
    return api.get<CompaniesListResponse>(`/v1/fulfilment/companies${query}`);
  },

  search: async (name: string, businessType?: string): Promise<Company[]> => {
    const params = new URLSearchParams({ name });
    if (businessType) params.set("business_type", businessType);
    const response = await api.get<{ companies: Company[] }>(
      `/v1/address-book/companies?${params.toString()}`,
    );
    return response.companies;
  },
};
